// extracted by mini-css-extract-plugin
export default {"app_banner":"AppBanner_app_banner__VgHg2"};